// Broad "an edit was committed" signal for the inline live preview.
//
// The inline preview is an iframe of the /preview route (see InlinePreviewPanel).
// It must reload whenever an edit is committed. We deliberately do NOT key off a
// single GraphQL query (e.g. pages.getWithChildren): text-content saves refetch
// only queries.cells.text.get, so a query-scoped trigger would silently miss the
// most common edit. Instead we listen at the Apollo link layer and bump this
// counter on ANY successful GraphQL mutation (see config.js). This is broader than
// strictly cell edits, which is fine: the preview is debounced and a stray reload
// is harmless. The panel subscribes to this counter.

let counter = 0;
const listeners = new Set();

export function bumpPreviewRefresh() {
  counter += 1;
  listeners.forEach((fn) => {
    try {
      fn(counter);
    } catch (e) {
      // a broken listener must not break the mutation flow
      console.error('previewRefresh listener error', e);
    }
  });
}

export function getPreviewRefreshCount() {
  return counter;
}

export function subscribePreviewRefresh(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
